
<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import store from "@/state/store";
var state = store._modules.root._children.auth.state;
export default {
  page: {
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      
      Customers: [],
      page: 1,
      limit: 20,
      tot_pages: 0,
      searchCustomers: null,
      CustomersSearchMode: false,
      searchModel: "",
      state: state,
    };
  },
  methods: {
    addCustomers() {
      console.log("**********####", this.state);
      var data = {
        title: "popups.addCustomers",
        inputs: [
        {"model":"chat_link",
"type":"text",
"label":"customers.chat_link"},
{"model":"email",
"type":"text",
"label":"customers.email"},
{"model":"created_at",
"type":"text",
"label":"customers.created_at"},
{"model":"first_name",
"type":"text",
"label":"customers.first_name"},
{"model":"district",
"type":"text",
"label":"customers.district"},
{"model":"full_name",
"type":"text",
"label":"customers.full_name"},
{"model":"updated_at",
"type":"text",
"label":"customers.updated_at"},
{"model":"magiclink",
"type":"text",
"label":"customers.magiclink"},
{"model":"phone_2",
"type":"text",
"label":"customers.phone_2"},
{"model":"last_name",
"type":"text",
"label":"customers.last_name"},
{"model":"botuserid",
"type":"text",
"label":"customers.botuserid"},
{"model":"phone",
"type":"text",
"label":"customers.phone"},
{"model":"city",
"type":"text",
"label":"customers.city"},

        ],
        buttons: [
          {
            text: "popups.add",
            closer: true,
            color: "primary",
            handler: (obj) => {
              this.http.post("customers", obj).then(() => {
                this.get(this.page);
              });
            },
          },
          {
            text: "popups.cancel",
            closer: true,
            color: "danger",
            handler: () => {
              console.log("Like Clicked");
            },
          },
        ],
      };
      this.popup.modal(data);
    },
    editCustomers(app) {
      var data = {
        title: "popups.customers",
        inputs: [
         {"model":"chat_link",
"type":"text",
"label":"customers.chat_link",
"value":app.chat_link
},
    {"model":"email",
"type":"text",
"label":"customers.email",
"value":app.email
},
    {"model":"created_at",
"type":"text",
"label":"customers.created_at",
"value":app.created_at
},
    {"model":"first_name",
"type":"text",
"label":"customers.first_name",
"value":app.first_name
},
    {"model":"district",
"type":"text",
"label":"customers.district",
"value":app.district
},
    {"model":"full_name",
"type":"text",
"label":"customers.full_name",
"value":app.full_name
},
    {"model":"updated_at",
"type":"text",
"label":"customers.updated_at",
"value":app.updated_at
},
    {"model":"magiclink",
"type":"text",
"label":"customers.magiclink",
"value":app.magiclink
},
    {"model":"phone_2",
"type":"text",
"label":"customers.phone_2",
"value":app.phone_2
},
    {"model":"last_name",
"type":"text",
"label":"customers.last_name",
"value":app.last_name
},
    {"model":"botuserid",
"type":"text",
"label":"customers.botuserid",
"value":app.botuserid
},
    {"model":"phone",
"type":"text",
"label":"customers.phone",
"value":app.phone
},
    {"model":"city",
"type":"text",
"label":"customers.city",
"value":app.city
},
    
        ],
        buttons: [
          {
            text: "popups.edit",
            closer: true,
            color: "primary",
            handler: (obj) => {
              this.http.put("customers", app.id, obj).then(() => {
                this.get(this.page);
              });
            },
          },
          {
            text: "popups.cancel",
            closer: true,
            color: "danger",
            handler: () => {
              console.log("Like Clicked");
            },
          },
        ],
      };
      this.popup.modal(data);
    },
    updateCustomers(app) {
      var data = {
        title: "popups.editfile",
        inputs: [
        {"model":"chat_link",
"type":"text",
"label":"customers.chat_link"},
{"model":"email",
"type":"text",
"label":"customers.email"},
{"model":"created_at",
"type":"text",
"label":"customers.created_at"},
{"model":"first_name",
"type":"text",
"label":"customers.first_name"},
{"model":"district",
"type":"text",
"label":"customers.district"},
{"model":"full_name",
"type":"text",
"label":"customers.full_name"},
{"model":"updated_at",
"type":"text",
"label":"customers.updated_at"},
{"model":"magiclink",
"type":"text",
"label":"customers.magiclink"},
{"model":"phone_2",
"type":"text",
"label":"customers.phone_2"},
{"model":"last_name",
"type":"text",
"label":"customers.last_name"},
{"model":"botuserid",
"type":"text",
"label":"customers.botuserid"},
{"model":"phone",
"type":"text",
"label":"customers.phone"},
{"model":"city",
"type":"text",
"label":"customers.city"},

        ],
        buttons: [
          {
            text: "popups.edit",
            closer: true,
            color: "primary",
            handler: (obj) => {
              obj.emp_id = app.id;
              this.http.do("customers", obj).then(() => {
                this.get(this.page);
              });
            },
          },
          {
            text: "popups.cancel",
            closer: true,
            color: "danger",
            handler: () => {
              console.log("Like Clicked");
            },
          },
        ],
      };
      this.popup.modal(data);
    },
    search() {
      this.CustomersSearchMode = true;
      this.tot_pages = 0;
      this.http
        .post("customers/search", {
          search: this.searchModel,
          limit: this.limit,
          page: this.page,
          col: "",
        })
        .then((res) => {
          this.Customers = res.data;
          console.log("######## files", this.Customers);
        });
    },
    cancelappsearchMode() {
      this.searchModel = "";
      this.CustomersSearchMode = false;
      this.get(this.page);
    },
   
    getCustomers() {
      this.http.get("customers").then((res) => {
        this.Customers = res.data;
      });
    },
    deleteCustomers(app) {
      var data = {
        title: "popups.deletefile",
        msg: "popups.delmessage",
      };
      this.popup.confirm(data).then((resp) => {
        if (resp) {
          console.log("###");
          this.http.delete("customers", app.id).then(() => {
            console.log("############################3");
            this.get(this.page);
          });
        }
      });
    },

    get(page) {
      console.log(page);
      this.http
        .post("customers/paginate", {
          limit: this.limit,
          page: page,
        })
        .then((res) => {
          this.page = page;
          this.tot_pages = Math.ceil(res.tot / this.limit);
          this.Customers = res.data;
          
        });
    },
  },
  created() {
    this.get(1);
    this.getCustomers();
  },
};
</script>

<template>
  <Layout>
    <PageHeader
      :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'"
      :title="$t('menu.menuitems.customers.text')"
    />
    <div class="row">
      <div class="col-6">
        <div class="search-box chat-search-box w-50">
          <div class="position-relative">
            <input
              @keyup="search()"
              type="text"
              class="form-control fa-lg text-light"
              :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'"
              :placeholder="$t('popups.search')"
              v-model="searchModel"
              style="background-color: #2a3042 !important"
            />
            <i class="bx bx-search-alt search-icon text-light"></i>
          </div>
        </div>
      </div>
      <div class="col-6" style="display: flex; justify-content: flex-end">
        <button
          class="btn-close text-light"
          v-if="CustomersSearchMode"
          @click="cancelappsearchMode()"
        ></button>
        <button
          type="button"
          @click="addCustomers()"
          class="btn btn-light float-end mb-4"
        >
          <span
            class="bx bxs-plus-circle float-end fa-2x"
            style="color: #2a3042 !important"
          ></span>
        </button>
      </div>
    </div>

    <table :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'" class="table">
      <thead>
        <tr
          class="text-light text-center"
          style="background-color: #2a3042 !important"
        >
        <th scope='col'>{{$t('customers.chat_link')}}
</th><th scope='col'>{{$t('customers.email')}}
</th><th scope='col'>{{$t('customers.created_at')}}
</th><th scope='col'>{{$t('customers.first_name')}}
</th><th scope='col'>{{$t('customers.district')}}
</th><th scope='col'>{{$t('customers.full_name')}}
</th><th scope='col'>{{$t('customers.updated_at')}}
</th><th scope='col'>{{$t('customers.magiclink')}}
</th><th scope='col'>{{$t('customers.phone_2')}}
</th><th scope='col'>{{$t('customers.id')}}
</th><th scope='col'>{{$t('customers.last_name')}}
</th><th scope='col'>{{$t('customers.botuserid')}}
</th><th scope='col'>{{$t('customers.phone')}}
</th><th scope='col'>{{$t('customers.city')}}
</th> 
        <th scope='col'>{{$t('customers.operations')}}
</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(app) in Customers" :key="app" class="text-center">
          <td>{{app.chat_link}}</td><td>{{app.email}}</td><td>{{app.created_at}}</td><td>{{app.first_name}}</td><td>{{app.district}}</td><td>{{app.full_name}}</td><td>{{app.updated_at}}</td><td>{{app.magiclink}}</td><td>{{app.phone_2}}</td><td>{{app.last_name}}</td><td>{{app.botuserid}}</td><td>{{app.phone}}</td><td>{{app.city}}</td>
          
          <td class="d-flex">
            <a
              class="btn btn-primary mx-1"
              @click="editCustomers(app)"
              href="javascript: void(0);"
              role="button"
              >{{ $t("popups.edit") }}</a
            >
            <a
              class="btn btn-danger"
              href="javascript: void(0);"
              role="button"
              @click="deleteCustomers(app)"
              >{{ $t("popups.delete") }}</a
            >
          </td>
        </tr>
      </tbody>
    </table>
    <!-- end  table -->
    <!-- Button trigger modal -->

    <div v-if="tot_pages == 20">
      <!--   Apps  paginate     -->
      <ul class="paginate paginate-rounded justify-content-center mb-2">
        <li class="page-item" :class="{ disabled: page == 1 }">
          <a
            class="page-link"
            href="javascript: void(0);"
            @click="get(page - 1)"
            aria-label="Previous"
          >
            <i class="mdi mdi-chevron-left"></i>
          </a>
        </li>
        <li
          class="page-item"
          :class="{ active: p == page }"
          v-for="p in tot_pages"
          :key="p"
        >
          <a class="page-link" href="javascript: void(0);" @click="get(p)">{{
            p
          }}</a>
        </li>

        <li class="page-item" :class="{ disabled: page == total_pages }">
          <a
            class="page-link"
            href="javascript: void(0);"
            @click="get(page + 1)"
            aria-label="Next"
          >
            <i class="mdi mdi-chevron-right"></i>
          </a>
        </li>
      </ul>
    </div>
    <!--end-->
  </Layout>
</template>

<style scoped>
.btn-close {
  position: relative;
  right: 317px;
  top: 6px;
  font-size: 15px;
}
</style>




